import NetworkService from "./networkService";
import { ApiUrl } from "../configs/path.config";

/**
 * Method will get powerbi embed
 */
export async function getPowerBIEmbed(reportId, scope) {
  let response = await NetworkService.getData(
    ApiUrl.getPowerBIEmbed(reportId, scope),
  );
  return response;
}

/**
 * Method to start Power BI report export
 */
export async function exportPowerBIReport(reportId, filterQueryString = "") {
  let response = await NetworkService.getData(
    ApiUrl.exportPowerBIReport(reportId, filterQueryString),
  );
  return response;
}

/**
 * Method to get Power BI export status
 */
export async function getPowerBIExportStatus(reportId, exportId) {
  let response = await NetworkService.getData(
    ApiUrl.getPowerBIExportStatus(reportId, exportId),
  );
  return response;
}

/**
 * Method to download Power BI report
 */
export function downloadPowerBIReport(reportId, exportId) {
  return ApiUrl.downloadPowerBIReport(reportId, exportId);
}
